module.exports = __webpack_public_path__ + "static/img/yin.77fc65e5.png";